module.exports = __webpack_public_path__ + "static/media/anc17ru.abdd4a98.pdf";